import { createCustomEntityId } from './utils'

export function generateNewCacheDataAddingDocument({
  cacheData,
  newDocument,
  owner: ownerCustomId,
  isArchived = false,
}) {
  const owner =
    typeof ownerCustomId === 'string'
      ? ownerCustomId
      : createCustomEntityId(ownerCustomId)

  const udpateEntity = (entity) => {
    const key = isArchived ? 'archivedDocuments' : 'documents'

    return {
      ...entity,
      [key]: [...entity[key], newDocument],
    }
  }

  const addDocument = (entity) =>
    createCustomEntityId(entity) === owner ? udpateEntity(entity) : entity

  return {
    ...cacheData,
    loan: {
      ...cacheData.loan,
      affiliates: cacheData.loan.affiliates.map(addDocument),
      businesses: cacheData.loan.businesses.map((b) => ({
        ...addDocument(b),
        corporateGuarantors: b.corporateGuarantors.map(addDocument),
        guarantors: b.guarantors.map(addDocument),
      })),
    },
  }
}

export function generateNewCacheDataExludingDocument({
  cacheData,
  documentId,
}) {
  const excludeDocument = (entity) => {
    return {
      ...entity,
      documents: entity.documents.filter((d) => d.rid !== documentId),
      archivedDocuments: entity.archivedDocuments.filter(
        (d) => d.rid !== documentId
      ),
    }
  }

  return {
    ...cacheData,
    loan: {
      ...cacheData.loan,
      affiliates: cacheData.loan.affiliates.map(excludeDocument),
      businesses: cacheData.loan.businesses.map((b) => ({
        ...excludeDocument(b),
        corporateGuarantors: b.corporateGuarantors.map(excludeDocument),
        guarantors: b.guarantors.map(excludeDocument),
      })),
    },
  }
}
